import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import { HOST_SERVER } from '../../../constants';
import s from './SinTurnosDisponibles.css';
// import ImageCalendar from '../../../../public/images/ic_calendar.png';
import ImageCalendar from '../../../../public/SVG/ic_calendar.svg';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';

class SinTurnosDisponibles extends React.Component {
  componentDidMount() {
    this.props.endResponse();
  }

  render() {
    return (
      <div className="col-md-12">
        <div className={`${s.divImagen} row`}>
          <div className="col-md-5" />
          <img src={ImageCalendar} alt="Anterior" />
        </div>
        <div className={`${s.divTexto} col-md-12`}>
          Por el momento no tenemos turnos disponibles para consultas online.<br />
          Estamos trabajando para ampliar la disponibilidad de turnos.<br />
          Podés agendar un Turno Presencial o ir a la Guardia más cercana.
        </div>
      </div>
    );
  }
}

SinTurnosDisponibles.propTypes = {
  endResponse: PropTypes.func.isRequired,
};

export default connect(null, telemedicinaActions)(
  withStyles(s)(SinTurnosDisponibles),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/SinTurnosDisponibles/SinTurnosDisponibles.js